/**
 * See the NOTICE file distributed with this work for additional information
 * regarding copyright ownership.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { useAppDispatch } from 'src/store';

import * as urlFor from 'src/shared/helpers/urlHelper';

import { resetForm } from 'src/content/app/tools/vep/state/vep-form/vepFormSlice';

import ToolsTopBar from 'src/content/app/tools/shared/components/tools-top-bar/ToolsTopBar';
import ButtonLink from 'src/shared/components/button-link/ButtonLink';
import EnsemblVepLogo from './EnsemblVepLogo';
import EnsemblVepVersion from './EnsemblVepVersion';
import VepTopBarNavButton from './VepTopBarNavButton';

import styles from './VepTopBar.module.css';

const VepGenericTopBar = () => {
  const dispatch = useAppDispatch();

  // Starting a new job should present a blank form: clear any species, input
  // and options left over from the previous submission before navigating.
  const onNewJob = () => {
    dispatch(resetForm());
  };

  return (
    <ToolsTopBar className={styles.vepGenericTopBar}>
      <div className={styles.vepGenericGrid}>
        <EnsemblVepLogo />
        <ButtonLink
          to={urlFor.vepForm()}
          className={styles.newJobButton}
          onClick={onNewJob}
        >
          New job
        </ButtonLink>
        <ResultsAvailabilityNotice />
        <EnsemblVepVersion />
        <VepTopBarNavButton />
      </div>
    </ToolsTopBar>
  );
};

const ResultsAvailabilityNotice = () => {
  return (
    <span className={styles.resultsAvailabilityNotice}>
      Results are available for 7 days from submission. Submissions are
      available and can be rerun for 28 days.
    </span>
  );
};

export default VepGenericTopBar;
